import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { KantoorLoginModule } from './kantoor-login.module';

// @ts-ignore
export const configuration: string = CONFIGURATION;

registerLocaleData(localeNl, 'nl');

if (configuration !== 'development') {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(KantoorLoginModule)
    // eslint-disable-next-line no-console
    .catch((err) => console.log(err)); //NOSONAR
